import {
    GET_STUDY_LEVELS_FAIL,
    GET_STUDY_LEVELS_SUCCESS,
    ADD_STUDY_LEVEL_SUCCESS,
    ADD_STUDY_LEVEL_FAIL,
    UPDATE_STUDY_LEVEL_SUCCESS,
    UPDATE_STUDY_LEVEL_FAIL,
    DELETE_STUDY_LEVEL_SUCCESS,
    DELETE_STUDY_LEVEL_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    studyLevels: [],
    error: null,
    loading: true,
    lastActionSuccess: false
};

const studyLevelReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des studyLevels
        case GET_STUDY_LEVELS_SUCCESS:
            return {
                ...state,
                studyLevels: action.payload.studyLevels, // tableau d'objets studyLevel
                loading: false,
                error: null,
                
            };

        case GET_STUDY_LEVELS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une studyLevele
        case ADD_STUDY_LEVEL_SUCCESS:
            return {
                ...state,
                studyLevels: [action.payload, ...state.studyLevels], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true,
            };

        case ADD_STUDY_LEVEL_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false,
            };

        // Mise à jour d'une studyLevele
        case UPDATE_STUDY_LEVEL_SUCCESS:
                console.log("Reducer: UPDATE_STUDY_LEVEL_SUCCESS", action.payload); // 🔹 debug
            return {
                ...state,
                studyLevels: state.studyLevels.map(studyLevel =>
                    studyLevel.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet studyLevel
                        : studyLevel
                ),
                error: null,
                lastActionSuccess: true,
            };

        case UPDATE_STUDY_LEVEL_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false,
            };

        // Suppression d'une studyLevele
        case DELETE_STUDY_LEVEL_SUCCESS:
            return {
                ...state,
                studyLevels: state.studyLevels.filter(
                    studyLevel => studyLevel.id !== action.payload
                ),
                error: null
            };


        case DELETE_STUDY_LEVEL_FAIL:
            return {
                ...state,
                error: action.payload
            };
        
        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        default:
            return state;
    }
};

export default studyLevelReducer;
